import React from "react"
import { SEOHead } from "components/SEO"
import FullyManagedOpenSourceBISection from "components/pages/use-cases/internal-bi/FullyManagedOpenSourceBISection"
import HeroSection from "components/pages/use-cases/internal-bi/HeroSection"
import ModernBISection from "components/pages/use-cases/internal-bi/ModernBISection"
import NoCodeVisualizationsSection from "components/pages/use-cases/internal-bi/NoCodeVisualizationsSection"
import SelfServeAnalyticsSection from "components/pages/use-cases/internal-bi/SelfServeAnalyticsSection"
import DividerSection from "components/ui/Blocks/DividerSection"
import DoubleCTASection from "components/ui/Blocks/DoubleCTASection"
import Layout from "components/ui/Layout"

function InternalBI({ location: { pathname } }) {
  return (
    <Layout
      contentSpaced
      trackingName="Use Cases - BI"
      pageName="internal-bi"
      pagePath={pathname}
    >
      <HeroSection />
      <div>
        <ModernBISection className="lg:-mt-10 xl:mt-0" />
        <NoCodeVisualizationsSection className="-my-20 2xl:-my-24" />
        <SelfServeAnalyticsSection />
        <FullyManagedOpenSourceBISection />
      </div>
      <DividerSection />
      <DoubleCTASection noHeading noBackground trackingName="Use Cases - BI" />
    </Layout>
  )
}

// Export a Head component for Gatsby Head API
export function Head() {
  return (
    <SEOHead
      title="Replace Legacy BI with Preset's Open Analytics Platform"
      description="Move beyond traditional BI limitations. Preset's open analytics platform delivers self-serve analytics, modern data stack integration, and enterprise security—without vendor lock-in."
    />
  )
}

export default InternalBI
